import {useDebugValue} from 'react';

import debugHook from './hookUtils';
import useStoreState from '../stores/useStoreState';
import DimensionsStore from '../stores/DimensionsStore';

export default debugHook(useScreenDimensions, 'useScreenDimensions');

export function useScreenDimensions() {
    const state = useStoreState(DimensionsStore, getStoreState);
    useDebugValue(state);
    return state;
}

function getStoreState() {
    return {
        width: DimensionsStore.get('width'),
        height: DimensionsStore.get('height'),
        isMobileWidth: DimensionsStore.isMobileWidth(),
        isTabletWidth: DimensionsStore.isTabletWidth(),
        isDesktopWidth: DimensionsStore.isDesktopWidth(),
        isDesktopLWidth: DimensionsStore.isDesktopLWidth(),
        isDesktopXLWidth: DimensionsStore.isDesktopXLWidth(),
    };
}
